import { render, staticRenderFns } from "./TournamentTotalsCard.vue?vue&type=template&id=c3f5485e&scoped=true"
import script from "./TournamentTotalsCard.vue?vue&type=script&lang=js"
export * from "./TournamentTotalsCard.vue?vue&type=script&lang=js"
import style0 from "./TournamentTotalsCard.vue?vue&type=style&index=0&id=c3f5485e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f5485e",
  null
  
)

export default component.exports